import React, { useState, useCallback } from 'react';
import gql from 'graphql-tag';
import classNames from 'classnames';
import { Link } from '../Link';
import { DesktopSiteNavItemFragment } from '../../generated/types/DesktopSiteNavItemFragment';
import {
  DesktopSiteNavPulldown,
  DESKTOP_SITE_NAV_PULLDOWN_FRAGMENT
} from './DesktopSiteNavPulldown';
import './DesktopSiteNavItem.scss';

export const DESKTOP_NAV_ITEM_FRAGMENT = gql`
  fragment DesktopSiteNavItemFragment on NavItem {
    id
    label
    href: url
    mobileOnly: mobile_only
    ...DesktopSiteNavPulldownFragment
  }
  ${DESKTOP_SITE_NAV_PULLDOWN_FRAGMENT}
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  navItem: DesktopSiteNavItemFragment;
  active: boolean;
}

export const DesktopSiteNavItem: React.FC<Props> = ({ className, navItem, active }) => {
  const [hover, setHover] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setHover(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHover(false);
  }, []);

  return navItem.id && navItem.href ? (
    <div
      className={classNames('DesktopSiteNavItem', className)}
      data-label={navItem.label?.toLowerCase()}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Link className="DesktopSiteNavItem__link" key={navItem.id} to={navItem.href}>
        {navItem.label}
      </Link>

      {hover && active && (
        <DesktopSiteNavPulldown className="DesktopSiteNavItem__pulldown" navItem={navItem} />
      )}
    </div>
  ) : null;
};
